<template>
  <apollo-query :query='listRemoteVideos'
                fetch-policy='cache-and-network'
                :update='onUpdate'
                :debounce='800'
                :variables='{cursor,size,search}'>
    <template v-slot='{ result: { loading, error, data }, isLoading, query }'>

      <loading v-if='isProcessing'>
        <p class="text-black text-lg font-semibold">Processing video...</p>
        <p class="text-gray-700 text-xs">Brought to you by tenor.com</p>
        <p class="text-black mb-2">This may take up to a minute.</p>
      </loading>

      <div class="relative mx-4 my-2">
        <span v-if='isLoading' class="apollo-spinner text-green-500" />
        <magnify v-else :size='32' class="apollo-search left-0 " />
        <input type="search"
               class="w-full m-1 bg-purple-white shadow rounded border-0 p-3 pl-10"
               placeholder="Search videos..."
               @input='(evt)=> { search=evt.target.value; }'
               :value='search' >
      </div>

      <div class="flex flex-row flex-wrap flex-none">
        <button v-for='related in (((data||{}).listRemoteVideos||{}).related||[]).slice(0,15)' :key='related' class="px-2 mx-1 h-6 bg-blue-600 text-white rounded-lg text-sm my-1" @click='search = related'>
          {{related}}
        </button>
      </div>

      <div class="w-full text-xs text-gray-600 text-right"><span class="text-right">brought to you by tenor.com</span></div>

      <div v-if='isLoading' class="spinner text-xl mt-8 mb-4" />

      <pbc-error v-if='error'
                 @close='error = ""'
                 message="There was a snag loading videos. Please retry." />

      <div class="grid grid-cols-3 gap-1">
        <button v-for='video in (((data||{}).listRemoteVideos||{}).items||[])'
                :key='video.mp4Url'
                style='background-color: #313131'
                @click='onSelectAnimation(video)'
                class="flex items-center justify-center">
          <img class='align-center object-contain h-32' :src='video.thumbnailGifUrl' loading="lazy" />
        </button>
      </div>
      <load-more v-if='(((data||{}).listRemoteVideos||{}).items||[]).length > 5' @load-more='onLoadMore(query, data, $event)' />

        <pbc-error v-if='processingError'
                   :retry='true'
                   @retry='processingError = ""'
                   message="That's our whoops. Cannot process video. Please try again or choose another."
                   :error='processingError'
                   >
        </pbc-error>
    </template>
  </apollo-query>
</template>
<script>
import ImportHelper from '@/ui/importhelper.js';
import UAParser from 'ua-parser-js';

import Magnify from '@icons/Magnify.vue';
import LoadMore from '@ui/atoms/LoadMore.vue';
import { listRemoteVideos, uploadRemoteVideo, uploadRemoteAnimation } from '@/gql/Queries.js';
import { uniqBy } from 'lodash';
import { mapState } from 'vuex';
export default {
  inject:['api'],
  props:{
  },
  data() {
    const uaparser = new UAParser();
    const isSafari = uaparser.getBrowser().name.toLowerCase().includes('safari');
    const search = this.$store.state.videoSearch;
    const importHelper = new ImportHelper(this.api, this.$apollo);
    return {
      listRemoteVideos,
      uploadRemoteVideo,
      uploadRemoteAnimation,
      isSafari,
      isProcessing: false,
      size:50,
      cursor:undefined,
      search,
      lastSearch:search,
      processingError: '',
      existingVideos: [],
      importHelper
    }
  },
  components: {
    LoadMore,
    Magnify
  },
  beforeDestroy() {
    this.importHelper.destroy();
  },
  methods: {
    onUpdate(data) {

      console.log('LS, search', this.lastSearch, this.search);
      if (this.lastSearch !== this.search) {
        this.lastSearch = this.search;
        this.existingVideos = [];
        console.log('return data');
        return data;
      }
      const newVideos = this.mergeVideos(this.existingVideos || [], data.listRemoteVideos.items);
      this.existingVideos = newVideos;

      data.listRemoteVideos.items = newVideos;

      this.lastSearch = this.search;

      this.$store.commit('setVideoSearch', this.search);

      if (this.search !== '') {
        this.$ana.track({
          eventCategory:'search',
          eventAction:'videos',
          extra:{
            search:this.search
          }
        });
      }
      return data;
    },
    mergeVideos(previous, fetchMore) {
      const items = [...previous, ...fetchMore];
      return uniqBy(items, ({mp4Url}) => {
        return mp4Url;
      });
    },
    async onLoadMore(query, data, $loadMore) {
      console.log('have data', data);

      const cursor = data.listRemoteVideos.cursor;
      console.log('incoming cursor', cursor);
      $loadMore.setLoading(true);
      const self = this;
      const fetchedMore = await query.fetchMore({
        variables:{
          cursor,
          size:this.size,
          search:this.search
        },
        updateQuery(prev, { fetchMoreResult }) {
          console.log('have prev', JSON.stringify(prev,0,2));
          console.log('FMR', fetchMoreResult);
          return Object.assign({}, prev, {
            listRemoteVideos: {
              cursor:fetchMoreResult.listRemoteVideos.cursor,
              items: self.mergeVideos(prev.listRemoteVideos.items, fetchMoreResult.listRemoteVideos.items),
              related: fetchMoreResult.listRemoteVideos.related,
              __typename:prev.listRemoteVideos.__typename
            },
            __typename:prev.__typename
          });
        }
      })
      $loadMore.setLoading(false);

      console.log('data after fetchmore', fetchedMore);
      if (fetchedMore.data.listRemoteVideos.cursor === '0') {
        $loadMore.setEnded(true);
      }
    },

    async onSelectAnimation(video) {

      console.log('selected', video);
      this.isProcessing = true;
      try {
        const animationData = await this.importHelper.importAnimation(video.gifUrl);
        this.isProcessing = false;
        this.$emit('select-animation', animationData);
      } catch (e) {
        this.isProcessing = false;
        this.processingError = 'Processing error'
        console.error('error importing', e);
      }
      /*
      try {
        const uploadedAnimation = await this.$apollo.mutate({
          mutation:this.uploadRemoteAnimation,
          variables:{
            url: video.gifUrl,
          },
          context: {
            timeout: 60 * 1000
          },
          error(error) {
            console.log('there is error', error);
            this.processingError = JSON.stringify(error.message);
            throw error;
          }
        });
        this.isProcessing = false;
        console.log('uploadedAnimation', uploadedAnimation);
        this.$emit("select-animation", uploadedAnimation.data.uploadRemoteAnimation);
      } catch (e) {
        this.isProcessing = false;
        console.error('errorzzzz', e);
        this.processingError = 'Processing error'
      }
      */
    },
    async onSelect(video) {

      console.log('selected', video);
      this.isProcessing = true;
      try {
        const uploadedVideo = await this.$apollo.mutate({
          mutation:this.uploadRemoteVideo,
          variables:{
            url: video.mp4Url,
            thumbnailUrl: video.thumbnailUrl
          },
          context: {
            timeout: 60 * 1000
          },
          error(error) {
            console.log('there is error', error);
            this.processingError = JSON.stringify(error.message);
            throw error;
          }
        });
        this.isProcessing = false;
        console.log('uploadedVideo', uploadedVideo);
        this.$emit("select", uploadedVideo.data.uploadRemoteVideo);
      } catch (e) {
        this.isProcessing = false;
        console.error('errorzzzz', e);
        this.processingError = 'Processing error'
      }
    }
  },
  computed: {
    ...mapState( ['videoSearch'] )
  }
}
</script>
